import { useEffect, useRef } from "react";

export function useEventListener<T extends HTMLElement>(
  type: string,
  handler: (ev: Event) => void
): React.RefObject<T> {
  const handlerRef = useRef(handler);
  const ref = useRef<T>(null);

  handlerRef.current = handler;

  useEffect(() => {
    if (ref.current) {
      const element = ref.current;
      const handler = (ev: Event) => handlerRef.current(ev);
      element.addEventListener(type, handler);
      return () => element.removeEventListener(type, handler);
    }
  }, [type]);

  return ref;
}
